import {
  GetDetailResponse,
  DailyActivity,
  PurchaseVasPayload,
  PurchaseVasQr,
  VasOptionList,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";

class _WalletService {
  public get(signal?: Signal) {
    return HttpService.get<GetDetailResponse<DailyActivity>>(
      "/user/api/v2/daily-activities",
      {
        signal,
      }
    );
  }

  public checkIn() {
    return HttpService.post("/user/api/v2/daily-activities/point");
  }

  public getVasOptions(signal?: Signal) {
    return HttpService.get<GetDetailResponse<VasOptionList>>(
      "/user/api/v2/vas-option",
      {
        signal,
      }
    );
  }

  public showQr(payload: PurchaseVasPayload) {
    return HttpService.post<GetDetailResponse<PurchaseVasQr>>(
      "/user/api/v2/purchase/vas",
      {
        body: { ...payload },
      }
    );
  }
}

const WalletService = new _WalletService();

export default WalletService;
